// extracted by mini-css-extract-plugin
export var ball1 = "f_G";
export var ball2 = "f_H";
export var bounce = "f_F";
export var fullscreen = "f_C";
export var spinner = "f_D";